import React from 'react';
import { motion } from 'framer-motion';

const IconPipelines = (props) => (
  <motion.svg {...props} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 25H80" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M20 50H80" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M20 75H80" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M25 25V75" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M50 25V75" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M75 25V75" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
  </motion.svg>
);

export default IconPipelines;